import { render, staticRenderFns } from "./HistorialQuejasPaciente.vue?vue&type=template&id=cf04389c&scoped=true"
import script from "./HistorialQuejasPaciente.vue?vue&type=script&lang=js"
export * from "./HistorialQuejasPaciente.vue?vue&type=script&lang=js"
import style0 from "./HistorialQuejasPaciente.vue?vue&type=style&index=0&id=cf04389c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf04389c",
  null
  
)

export default component.exports